module.exports = __webpack_public_path__ + "img/commentsTip.8797fc96.png";